import React, { useState, useEffect } from 'react';
import { auth, provider, db } from '../firebase/config';
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { saveCandidate, updateisLoginStatus, checkLoginStatus } from '../Api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageVisible, setMessageVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem('loggedInUserId');
    if (userId) {
      navigate('/');
    }
  }, [navigate]);

  // Disable right-click and common inspect shortcuts
  // useEffect(() => {
  //   const handleContextMenu = (e) => e.preventDefault();
  
  //   const handleKeyDown = (e) => {
  //     if (e.key === 'F12') {
  //       e.preventDefault();
  //       return false;
  //     }
  //     if (
  //       (e.ctrlKey || e.metaKey) && 
  //       (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
  //     ) {
  //       e.preventDefault();
  //       return false;
  //     }
  //     if (
  //       (e.ctrlKey || e.metaKey) &&
  //       ['U', 'S', 'P'].includes(e.key.toUpperCase())
  //     ) {
  //       e.preventDefault();
  //       return false;
  //     }
  //   };
  
  //   window.addEventListener('contextmenu', handleContextMenu);
  //   window.addEventListener('keydown', handleKeyDown);
  
  //   return () => {
  //     window.removeEventListener('contextmenu', handleContextMenu);
  //     window.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);


  // Redirect if not logged in
  const userId = localStorage.getItem('loggedInUserId');
  if (userId) {
    navigate('/');
    return;
  }

  const showMessage = (text, isError = false) => {
    setMessage(text);
    setMessageVisible(true);
    const color = isError ? 'red' : 'green';
    document.getElementById('loginInMessage').style.color = color;

    setTimeout(() => {
      setMessageVisible(false);
    }, 5000);
  };

  const handleManualLogin = async (e) => {
    e.preventDefault();
    try {
      // check if user is already logged in on another device
      const statusResponse = await checkLoginStatus(email);
      if (statusResponse.isLoggedIn === 1) {
        showMessage("This account is in use on another device.", true);
        return;
      }

      const result = await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem('loggedInUserId', result.user.uid);
      // storing token 
      const token = await result.user.getIdToken();
      localStorage.setItem('authToken', token);
      showMessage('Login successful!');

      // Update isLoggedIn to 1 in the database
      const uid = result.user.uid;
      await updateisLoginStatus(uid, 1)

      setTimeout(() => navigate('/'), 1500);
    } catch (error) {
      let message = '';
      switch (error.code) {
        case 'auth/invalid-email':
          message = 'Invalid email address. Please check and try again.';
          break;
        case 'auth/invalid-credential':
          message = 'Invalid email or password. Please check and try again.';
          break;
        case 'auth/user-disabled':
          message = 'This account has been disabled. Contact support.';
          break;
        case 'auth/user-not-found':
          message = 'No account found with this email. Please sign up first.';
          break;
        case 'auth/wrong-password':
          message = 'Incorrect password. Please try again.';
          break;
        case 'auth/too-many-requests':
          message = 'Too many failed attempts. Please wait and try again.';
          break;
        case 'auth/network-request-failed':
          message = 'Network error. Please check your internet connection.';
          break;
        default:
          message = `Login failed: ${error.message}`;
          break;
      }
      showMessage(message, true);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const token = await user.getIdToken();
      localStorage.setItem('authToken', token);
      const uid = user.uid;
      const email = user.email;

      // Check if already logged in
      const statusResponse = await checkLoginStatus(email);
      if (statusResponse?.isLoggedIn === 1) {
        showMessage('This account is in use on another device.', true);
        return;
      }
      localStorage.setItem('loggedInUserId', uid);

      await setDoc(doc(db, "candidates", uid), {
        email: user.email,
        firstName: user.displayName?.split(" ")[0] || "",
        lastName: user.displayName?.split(" ")[1] || "",
      }, { merge: true });
      showMessage('Google login successful!');
      setTimeout(() => navigate('/'), 3000);

      // Save to MySQL
      const response = await saveCandidate({
        uid,
        email: user.email,
        fullName: user.displayName || '',
        firstName: user.displayName?.split(" ")[0] || '',
        lastName: user.displayName?.split(" ")[1] || '',
        phone: ''
      });

      if (response.status !== 200) {
        console.warn('Failed to save candidate:', response.message);
      }

      // Update isLoggedIn to 1 in the database
      await updateisLoginStatus(uid, 1);

      // if (response.status === 409) {
      //   console.info('Email already exists in MySQL. Skipping insert.');
      // } else if (response.status !== 200) {
      //   console.warn('Failed to save candidate:', response.message);
      // }

    } catch (error) {
      let message = '';
      switch (error.code) {
        case 'auth/popup-closed-by-user':
          message = 'Google sign-in was cancelled.';
          break;
        case 'auth/cancelled-popup-request':
          message = 'Another sign-in process is already in progress.';
          break;
        case 'auth/popup-blocked':
          message = 'Popup was blocked by the browser. Enable popups to continue.';
          break;
        case 'auth/account-exists-with-different-credential':
          message = 'An account with the same email exists. Use the correct login method.';
          break;
        case 'auth/network-request-failed':
          message = 'Network error. Please check your connection.';
          break;
        default:
          message = `Google login failed: ${error.message}`;
          break;
      }
      showMessage(message, true);
    }
  };

  return (
    <>
    <Header />
    <div className="login-page" style={{ backgroundColor: '#FFFDF6'}}>
      <div className="container d-flex align-items-center vh-100">
        <div className="form-holder shadow-lg w-100">
          <div className="row">
            {/* Info Panel */}
            <div className="col-lg-6 position-relative text-center" style={{ backgroundColor: '#113d6e'}}>
              <img src="/images/logofs.png" alt="logo" width="250" height="180" className="position-absolute top-0 start-50 translate-middle-x mt-5 d-lg-block d-none"/>
              <div className="info d-flex flex-column justify-content-center h-100 text-light">
                <div className="content d-lg-block d-none">
                  <h1>Login Now</h1>
                </div>
                <div
                  id="loginInMessage"
                  className="messageDiv"
                  style={{
                    display: messageVisible ? 'block' : 'none',
                    opacity: messageVisible ? 1 : 0,
                    transition: 'opacity 0.5s',
                    marginTop: '10px'
                  }}
                >
                  {message}
                </div>
              </div>
              <img src="/images/india.png" alt="india" width="100%" className="position-absolute bottom-0 start-0"/>
            </div>

            {/* Form Panel */}
            <div className="col-lg-6 bg-white d-flex align-items-center p-5">
              <div className="w-100 px-4">
                <form onSubmit={handleManualLogin}>
                  <div className="form-group mb-3">
                    <h2 className='mb-5'>Login</h2>
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      required
                      value={email}
                      placeholder='Enter Registered Email'
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control"
                      required
                      value={password}
                      placeholder='Enter Password'
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-info">Login Now</button>
                  </div>
                </form>
                <div className="text-center mt-3">
                  <a href="/forgotPassword">Forgot Password?</a><br />
                  <small>Don't have an account?</small> <a href="/signup">Signup</a>
                  <p className="mt-3">----------------OR-------------------</p>
                  <button onClick={handleGoogleLogin} className="btn btn-outline-danger w-100">
                    Sign in with Google
                  </button>
                  <p className="mb-0 mt-3">&copy; {new Date().getFullYear()} Freshskills. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
    <Footer />
    </>
  );
};

export default LoginPage;
